export default __webpack_public_path__ + "static/media/audio_play.4c732616.svg";